import React from 'react';
import { formatValue } from '../../charts/chartUtils';

export function MetricCardBlock({ data }) {
    const rows = data?.rows || [];

    return (
        <div className="metric-card-block">
            <div className="metrics-grid">
                {rows.map((row, index) => (
                    <div key={index} className="metric-item">
                        <span className="metric-label">{row.metric}</span>
                        <span className="metric-value">
                            {formatValue(row.value, row.format)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
